export const conversationTabs = ['rpm', 'ccm', 'unregistered'];
export const registeredConversationTabs = ['rpm', 'ccm'];
